import { render, staticRenderFns } from "./ConsolePage.vue?vue&type=template&id=4073c450&"
import script from "./ConsolePage.vue?vue&type=script&lang=js&"
export * from "./ConsolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports